import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import Card from '@/components/Card'
import PaginationTable from '@/components/PaginationTable'
import attributeShape from '@/pages/OrganizationUserAttributesPage/attributeShape'
import cn from '@/utilities/cn'

import columns from './columns'

import './index.scss'

const AttributeList = ({ attributes, onDelete, onEdit }: any) => {
  const intl = useIntl()

  return (
    <Card>
      <Card.Content>
        <PaginationTable
          className="attribute-list__table"
          columns={columns({ intl, onDelete, onEdit })}
          onRow={onRow}
          rowKey="id"
          rows={attributes}
        />
      </Card.Content>
    </Card>
  )
}

const onRow = ({ scimParentAttributeName = null }) => ({
  className: cn('attribute-list__row', { 'attribute-list__row--child': !!scimParentAttributeName })
})

AttributeList.displayName = 'AttributeList'

AttributeList.propTypes = {
  attributes: PropTypes.arrayOf(attributeShape),

  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
}

AttributeList.defaultProps = {
  attributes: []
}

export default AttributeList
